<!-- 타겟그룹 활동 필터 -->
<template>
  <div>
    <div v-if="isActivity">
      <!-- 교차 조건 설정 영역-->
      <b-row class="mt-1">
        <b-col cols="12">
          <label class="d-block">교차 조건</label>
          <b-form-radio-group
            v-model="isAndCross"
            :disabled="isReadonly"
          >
            <b-form-radio
              class="custom-control-primary"
              :value="false"
            >
              OR
            </b-form-radio>
            <b-form-radio
              class="custom-control-primary"
              :value="true"
            >
              AND
            </b-form-radio>
          </b-form-radio-group>
        </b-col>
      </b-row>
      <!-- 활동 필터 설정 영역-->
      <b-row class="mt-1">
        <b-col cols="12">
          <label class="d-block">활동</label>
          <b-button
            :disabled="isReadonly"
            variant="outline-primary"
            @click.prevent="showTargetGroupFilters(activityDrugInfoTypeCode)"
          >
            <feather-icon
              icon="SearchIcon"
              class="mr-50"
            />
            <span>약품정보 추가</span>
          </b-button>
          <b-button
            :disabled="isReadonly"
            variant="outline-primary"
            class="ml-1"
            @click.prevent="showTargetGroupFilters(activityMedicalTrendTypeCode)"
          >
            <feather-icon
              icon="SearchIcon"
              class="mr-50"
            />
            <span>메디컬트렌드 추가</span>
          </b-button>
          <b-button
            :disabled="isReadonly"
            variant="outline-primary"
            class="ml-1"
            @click.prevent="showTargetGroupFilters(activitySurveyTypeCode)"
          >
            <feather-icon
              icon="SearchIcon"
              class="mr-50"
            />
            <span>설문조사 추가</span>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col cols="12">
          <validation-observer ref="activityRules">
            <b-table
              :items="activityFilters"
              :fields="selectedTableColumns"
              :hover="false"
              bordered
              empty-text="추가된 게시글이 없습니다."
              show-empty
              tbody-tr-class="no-hover-row"
            >
              <template #row-details="row">
                <b-card
                  no-body
                  class="m-0 details-card"
                >
                  <table class="table details-table mb-0">
                    <tbody>
                      <!-- 약품정보: 타겟 대상 (컨텐츠 열람 기반 / 팝업 반응 기반) -->
                      <template v-if="row.item.filterType === activityDrugInfoTypeCode">
                        <tr>
                          <td style="width: 10%;">
                            타겟 대상
                          </td>
                          <td>
                            <b-form-radio-group
                              v-model="row.item.targetActionCategory"
                              :disabled="isReadonly"
                              @change="changeTargetActionCategory(row.item)"
                            >
                              <b-form-radio
                                v-for="opt in drugInfoActionCategoryOptions"
                                :key="opt.code"
                                :value="opt.code"
                                button
                                :button-variant="row.item.targetActionCategory === opt.code ? 'primary' : 'outline-primary'"
                                class="mr-1 category-pill-btn"
                              >
                                {{ opt.label }}
                              </b-form-radio>
                            </b-form-radio-group>
                          </td>
                        </tr>
                        <!-- 컨텐츠 열람 기반: 서브 타이틀(좌) + 라디오(우) 한 행 -->
                        <tr v-if="row.item.targetActionCategory === ACTION_CATEGORY.CONTENT_VIEW">
                          <td style="width: 10%;">
                            <span style="font-weight: 500;">
                              컨텐츠 열람 선택
                              <b-badge
                                v-b-tooltip.hover.right.html
                                variant="light-secondary"
                                style="padding: 0px; margin-left: 5px;"
                                :title="`<ul style='text-align: left; padding-left: 1rem; margin: 0;'>
                                          <li>컨텐츠 열람 : 해당 컨텐츠의 타겟과 관계없이 컨텐츠의 상세 내용을 확인한 상태</li>
                                          <li>컨텐츠 미열람 : 해당 컨텐츠의 타겟 내에서 컨텐츠의 상세 내용을 확인하지 않은 상태</li>
                                        </ul>`"
                              >
                                <feather-icon icon="InfoIcon" />
                              </b-badge>
                            </span>
                          </td>
                          <td>
                            <b-form-radio-group
                              v-model="row.item.targetActionType"
                              :options="contentViewActionOptions"
                              :disabled="isReadonly"
                              value-field="code"
                              text-field="label"
                              @change="changeTargetActionType(row.item)"
                            />
                          </td>
                        </tr>
                        <!-- 팝업 반응 기반: 서브 타이틀(좌) + 라디오(우) 한 행 -->
                        <tr v-if="row.item.targetActionCategory === ACTION_CATEGORY.POPUP_REACTION">
                          <td style="width: 10%;">
                            <span style="font-weight: 500;">
                              팝업 반응 선택
                              <b-badge
                                v-b-tooltip.hover.right.html
                                variant="light-secondary"
                                style="padding: 0px; margin-left: 5px;"
                                :title="`<ul style='text-align: left; padding-left: 1rem; margin: 0;'>
                                          <li>팝업 클릭 : 팝업이 노출되었고 사용자가 클릭함</li>
                                          <li>팝업 무시 : 팝업이 노출되었으나 클릭하지 않음</li>
                                          <li>팝업 미노출 : 해당 컨텐츠의 타겟내에서 조건 미달로 팝업이 노출되지 않음</li>
                                        </ul>`"
                              >
                                <feather-icon icon="InfoIcon" />
                              </b-badge>
                            </span>
                          </td>
                          <td>
                            <b-form-radio-group
                              v-model="row.item.targetActionType"
                              :options="popupReactionActionOptions"
                              :disabled="isReadonly"
                              value-field="code"
                              text-field="label"
                              @change="changeTargetActionType(row.item)"
                            />
                          </td>
                        </tr>
                        <!-- 타겟 경로 (컨텐츠 미열람 · 팝업 미노출 제외) -->
                        <tr v-if="showTargetRouteRow(row.item)">
                          <td style="width: 10%;font-weight: 500;">
                            타겟 경로
                          </td>
                          <td>
                            <div class="d-flex align-items-center">
                              <b-form-input
                                v-model="row.item.targetRouteName"
                                style="width: 40%;"
                                readonly
                              />
                              <b-button
                                variant="outline-primary"
                                class="mt-0 ml-1"
                                :disabled="isReadonly"
                                @click.prevent="targetRouteSelect.open(row.item)"
                              >
                                <span>경로 선택</span>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                      </template>
                      <!-- 메디컬트렌드: 컨텐츠 열람 기반 라디오만 -->
                      <template v-if="row.item.filterType === activityMedicalTrendTypeCode">
                        <tr>
                          <td style="width: 10%;">타겟 대상</td>
                          <td>
                            <span>컨텐츠 열람 기반</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 10%;">
                            <span style="font-weight: 500;">
                              컨텐츠 열람 선택
                              <b-badge
                                v-b-tooltip.hover.right.html
                                variant="light-secondary"
                                style="padding: 0px; margin-left: 5px;"
                                :title="`<ul style='text-align: left; padding-left: 1rem; margin: 0;'>
                                          <li>컨텐츠 열람 : 해당 컨텐츠의 타겟과 관계없이 컨텐츠의 상세 내용을 확인한 상태</li>
                                          <li>컨텐츠 미열람 : 해당 컨텐츠의 타겟 내에서 컨텐츠의 상세 내용을 확인하지 않은 상태</li>
                                        </ul>`"
                              >
                                <feather-icon icon="InfoIcon" />
                              </b-badge>
                            </span>
                          </td>
                          <td>
                            <b-form-radio-group
                              v-model="row.item.targetActionType"
                              :options="contentViewActionOptions"
                              :disabled="isReadonly"
                              value-field="code"
                              text-field="label"
                              @change="changeTargetActionType(row.item)"
                            />
                          </td>
                        </tr>
                      </template>
                      <!-- 설문조사: 설문 완료 / 설문 미완료 -->
                      <template v-if="row.item.filterType === activitySurveyTypeCode">
                        <tr>
                          <td style="width: 10%;">타겟 대상</td>
                          <td>
                            <span>설문 상태 기반</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="width: 10%;">
                            <span style="font-weight: 500;">
                              설문 상태 선택
                              <b-badge
                                v-b-tooltip.hover.right.html
                                variant="light-secondary"
                                style="padding: 0px; margin-left: 5px;"
                                :title="`<ul style='text-align: left; padding-left: 1rem; margin: 0;'>
                                          <li>설문 완료 : 설문 응답 후 최종 제출 버튼까지 클릭하여 전송 완료한 상태</li>
                                          <li>설문 미완료 : 해당 설문의 타겟 내에서 설문을 열람과 관계없이 '설문 완료'하지 않은 상태</li>
                                        </ul>`"
                              >
                                <feather-icon icon="InfoIcon" />
                              </b-badge>
                            </span>
                          </td>
                          <td>
                            <b-form-radio-group
                              v-model="row.item.targetActionType"
                              :options="surveyActionOptions"
                              :disabled="isReadonly"
                              value-field="code"
                              text-field="label"
                              @change="changeTargetActionType(row.item)"
                            />
                          </td>
                        </tr>
                      </template>
                      <!-- 조회 기간 (미열람/미노출/미완료 제외) -->
                      <tr v-if="showDateRangeRow(row.item)">
                        <td style="width: 10%;font-weight: 500;">
                          조회 기간
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <b-form-group
                              :label-for="`datepicker-start-${row.item.filterId}`"
                              class="mb-0"
                            >
                              <validation-provider
                                #default="{ errors, failedRules }"
                                :name="`조회기간(Fr)-${row.item.filterId}`"
                                :rules="{
                                  required: true,
                                  dateBetween: [row.item.filterStartDate, row.item.filterEndDate],
                                }"
                                :immediate="true"
                                :bails="false"
                                mode="aggressive"
                              >
                                <b-form-datepicker
                                  :id="`datepicker-start-${row.item.filterId}`"
                                  v-model="row.item.startDate"
                                  placeholder="조회기간(Fr)"
                                  :state="errors.length > 0 ? false : null"
                                  :disabled="isReadonly"
                                  :max="yesterdayDate"
                                />
                                <small
                                  v-if="failedRules.dateBetween"
                                  class="text-danger"
                                >
                                  [조회기간]은 게시 기간 내로 설정해야 합니다.
                                </small>
                              </validation-provider>
                            </b-form-group>
                            <label class="mr-25 ml-25">~</label>
                            <b-form-group
                              :label-for="`datepicker-end-${row.item.filterId}`"
                              class="mb-0"
                            >
                              <validation-provider
                                #default="{ errors, failedRules }"
                                :name="`조회기간(To)-${row.item.filterId}`"
                                :rules="{
                                  required: true,
                                  dateBetween: [row.item.filterStartDate, row.item.filterEndDate],
                                }"
                                :immediate="true"
                                :bails="false"
                                mode="aggressive"
                              >
                                <b-form-datepicker
                                  :id="`datepicker-end-${row.item.filterId}`"
                                  v-model="row.item.endDate"
                                  placeholder="조회기간(To)"
                                  :state="errors.length > 0 ? false : null"
                                  :disabled="isReadonly"
                                  :max="yesterdayDate"
                                />
                                <small
                                  v-if="failedRules.dateBetween"
                                  class="text-danger d-block"
                                >
                                  [조회기간]은 게시 기간 내로 설정해야 합니다.
                                </small>
                              </validation-provider>
                            </b-form-group>
                          </div>
                          <validation-provider
                            #default="{ errors, failedRules }"
                            v-model="row.item.startDate"
                            :name="`조회기간 3개월-${row.item.filterId}`"
                            :rules="{
                              dateWithin3Months: { otherDate: row.item.endDate },
                            }"
                            :immediate="true"
                            mode="passive"
                          >
                            <input
                              type="hidden"
                              :value="row.item.startDate"
                            >
                            <small
                              v-if="failedRules.dateWithin3Months"
                              class="text-danger d-block"
                            >
                              [조회기간]은 3개월 이내로 설정해야 합니다.
                            </small>
                          </validation-provider>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-card>
              </template>
              <template #cell(clientName)="data">
                {{ data.value === null || data.value === '' ? '-' : data.value }}
              </template>
              <template #cell(filterType)="data">
                {{ getFilterTypeLabel(data.value) }}
              </template>
              <template #cell(isMainView)="data">
                <div
                  class="text-nowrap"
                  style="text-align: center;"
                >
                  {{ data.value === null || data.value === '' ? '-' : (data.value ? 'O' : 'X') }}
                </div>
              </template>
              <template #cell(isInfoPopUp)="data">
                <div
                  class="text-nowrap"
                  style="text-align: center;"
                >
                  {{ data.value ? 'O' : 'X' }}
                </div>
              </template>
              <template #cell(isScheduleUse)="data">
                <div
                  class="text-nowrap"
                  style="text-align: center;"
                >
                  {{ data.value ? 'O' : 'X' }}
                </div>
              </template>
              <template #cell(isAfterConsultPopup)="data">
                <div
                  class="text-nowrap"
                  style="text-align: center;"
                >
                  {{ data.value === null || data.value === undefined ? '-' : (data.value ? 'O' : 'X') }}
                </div>
              </template>
              <template #cell(isDelete)="data">
                <b-button
                  variant="link"
                  size="sm"
                  class="btn-hover-trash"
                  :disabled="isReadonly"
                  @click.prevent="removeRow(data.item.filterType, data.item)"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    size="16"
                    class="text-danger"
                  />
                </b-button>
              </template>
            </b-table>
          </validation-observer>
        </b-col>
      </b-row>
    </div>

    <!-- 약품정보 선택 모달 -->
    <drug-info-select
      v-if="activityDrugInfoTypeCode"
      :show-drug-info-select="showDrugInfoSelect"
      :filter-type="activityDrugInfoTypeCode"
      :selected-value="selectedFilterIds"
      @close="drugInfoSelect.close"
    />

    <!-- 메디컬트렌드 선택 모달 -->
    <medical-trend-select
      v-if="activityMedicalTrendTypeCode"
      :show-medical-trend-select="showMedicalTrendSelect"
      :filter-type="activityMedicalTrendTypeCode"
      :selected-value="selectedFilterIds"
      @close="medicalTrendSelect.close"
    />

    <!-- 설문조사 선택 모달 -->
    <survey-select
      v-if="activitySurveyTypeCode"
      :show-survey-select="showSurveySelect"
      :filter-type="activitySurveyTypeCode"
      :selected-value="selectedFilterIds"
      @close="surveySelect.close"
    />

    <action-route-select
      :show-action-route-select="showActionRouteSelect"
      :codes="codes"
      :selected-value="currentFilter && currentFilter.targetRouteCodes ? currentFilter.targetRouteCodes : ''"
      :action-type="currentFilter && currentFilter.targetActionType ? currentFilter.targetActionType : 1"
      @close="targetRouteSelect.close"
    />
  </div>
</template>

<script>
import {
  ref, computed, set, watch,
  getCurrentInstance,
} from '@vue/composition-api'
import { VBTooltip, BCard, BBadge } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { arrayJoinStr } from '@core/utils/filter'
import dayjs from 'dayjs'
import DrugInfoSelect from '../../druginfo-manage/DrugInfoSelect.vue'
import MedicalTrendSelect from '../../medicaltrend-manage/MedicalTrendSelect.vue'
import SurveySelect from '../../survey-manage/SurveySelect.vue'
import ActionRouteSelect from '../../../popup/ActionRouteSelect.vue'

extend('dateWithin3Months', {
  params: ['otherDate'],
  validate(value, { otherDate }) {
    if (!value || !otherDate) return true
    const date1 = dayjs(value)
    const date2 = dayjs(otherDate)
    const diffMonths = Math.abs(date1.diff(date2, 'month', true))
    return diffMonths <= 3
  },
  message: '[조회기간]은 3개월 이내로 설정해야 합니다.',
})

export default {
  components: {
    DrugInfoSelect,
    MedicalTrendSelect,
    SurveySelect,
    ActionRouteSelect,
    BCard,
    BBadge,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    targetGroupData: {
      type: Object,
      required: true,
    },
    codes: {
      type: Object,
      required: true,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    filterType: {
      type: Number,
      required: false,
      default: null,
    },
    activityToggleState: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    // === 활동 타겟 액션타입 상수 (BE enum과 매핑) ===
    // 기존: PostViewer=1, PopupNonClicker=2
    // 신규 7종
    const ACTION_TYPE = Object.freeze({
      POST_VIEWER: 1, // (레거시) 컨텐츠 열람 = 11로 대체
      POPUP_NON_CLICKER: 2, // (레거시) 팝업 무시 = 22로 대체
      CONTENT_VIEWER: 11,
      CONTENT_NON_VIEWER: 12,
      POPUP_CLICKER: 21,
      POPUP_IGNORER: 22,
      POPUP_NOT_SHOWN: 23,
      SURVEY_COMPLETER: 31,
      SURVEY_NON_COMPLETER: 32,
    })
    // 약품정보 타겟 대상 카테고리 (UI 전용: 라디오 상위 그룹)
    const ACTION_CATEGORY = Object.freeze({
      CONTENT_VIEW: 1, // 컨텐츠 열람 기반
      POPUP_REACTION: 2, // 팝업 반응 기반
    })

    const drugInfoActionCategoryOptions = [
      { code: ACTION_CATEGORY.CONTENT_VIEW, label: '컨텐츠 열람 기반' },
      { code: ACTION_CATEGORY.POPUP_REACTION, label: '팝업 반응 기반' },
    ]
    const contentViewActionOptions = [
      { code: ACTION_TYPE.CONTENT_VIEWER, label: '컨텐츠 열람' },
      { code: ACTION_TYPE.CONTENT_NON_VIEWER, label: '컨텐츠 미열람' },
    ]
    const popupReactionActionOptions = [
      { code: ACTION_TYPE.POPUP_CLICKER, label: '팝업 클릭' },
      { code: ACTION_TYPE.POPUP_IGNORER, label: '팝업 무시' },
      { code: ACTION_TYPE.POPUP_NOT_SHOWN, label: '팝업 미노출' },
    ]
    const surveyActionOptions = [
      { code: ACTION_TYPE.SURVEY_COMPLETER, label: '설문 완료' },
      { code: ACTION_TYPE.SURVEY_NON_COMPLETER, label: '설문 미완료' },
    ]

    // 하단(타겟 경로/조회 기간) UI 노출 제외 액션타입: 미열람/미노출/미완료
    const ACTION_TYPES_HIDING_LOWER_UI = [
      ACTION_TYPE.CONTENT_NON_VIEWER,
      ACTION_TYPE.POPUP_NOT_SHOWN,
      ACTION_TYPE.SURVEY_NON_COMPLETER,
    ]
    // 타겟 경로 UI가 애초에 없는 액션타입 (팝업 무시 · 설문 관련)
    // 타겟 경로 표시 조건: 약품정보 카드 + (컨텐츠 열람 or 팝업 클릭/팝업 무시)
    const ACTION_TYPES_WITH_TARGET_ROUTE = [
      ACTION_TYPE.CONTENT_VIEWER,
      ACTION_TYPE.POPUP_CLICKER,
      ACTION_TYPE.POPUP_IGNORER,
    ]

    const showDateRangeRow = item => !ACTION_TYPES_HIDING_LOWER_UI.includes(item.targetActionType)
    const showTargetRouteRow = item => ACTION_TYPES_WITH_TARGET_ROUTE.includes(item.targetActionType)

    const activityDrugInfoTypeCode = computed(() => {
      const item = props.codes.targetGroupFilterType?.find(x => x.label === '활동_약품정보')
      return item?.code || null
    })

    const activityMedicalTrendTypeCode = computed(() => {
      const item = props.codes.targetGroupFilterType?.find(x => x.label === '활동_메디컬트렌드')
      return item?.code || null
    })

    const activitySurveyTypeCode = computed(() => {
      const item = props.codes.targetGroupFilterType?.find(x => x.label === '활동_설문조사')
      return item?.code || null
    })

    const isActivity = computed(() => props.activityToggleState)
    // 정렬: filterType(카테고리) 오름차순 → 카테고리 내에서는 stable sort로 원본 순서(추가 순서/저장 시 CreateDate 순) 유지
    const activityFilters = computed(() => props.targetGroupData.targetGroupFilters
      .filter(x => {
        const typeOffset = x.filterType - props.filterType
        return typeOffset >= 0 && typeOffset < 10 // 40번대만 조회
      })
      .sort((a, b) => a.filterType - b.filterType))
    const isAndCross = ref(true)

    const selectedFilterIds = computed(() => activityFilters.value.filter(x => x.filterType === activityDrugInfoTypeCode.value || x.filterType === activityMedicalTrendTypeCode.value || x.filterType === activitySurveyTypeCode.value).map(item => item.filterId))
    const yesterdayDate = dayjs().add(-1, 'day').format('YYYY-MM-DD')

    watch(activityFilters, newFilters => {
      if (newFilters && newFilters.length > 0) {
        // 첫 번째 필터의 isAndCross 값으로 동기화
        isAndCross.value = newFilters[0].isAndCross ?? false

        // 기존 저장 데이터(액션타입 1/2) → 신규 값으로 정규화 + 약품정보 카테고리 계산
        newFilters.forEach(f => {
          if (f.filterType === activityDrugInfoTypeCode.value) {
            // 레거시 매핑
            if (f.targetActionType === ACTION_TYPE.POST_VIEWER) set(f, 'targetActionType', ACTION_TYPE.CONTENT_VIEWER)
            else if (f.targetActionType === ACTION_TYPE.POPUP_NON_CLICKER) set(f, 'targetActionType', ACTION_TYPE.POPUP_IGNORER)

            // 약품정보 카테고리 자동 결정
            if (f.targetActionCategory === undefined || f.targetActionCategory === null) {
              if ([ACTION_TYPE.CONTENT_VIEWER, ACTION_TYPE.CONTENT_NON_VIEWER].includes(f.targetActionType)) {
                set(f, 'targetActionCategory', ACTION_CATEGORY.CONTENT_VIEW)
              } else if ([ACTION_TYPE.POPUP_CLICKER, ACTION_TYPE.POPUP_IGNORER, ACTION_TYPE.POPUP_NOT_SHOWN].includes(f.targetActionType)) {
                set(f, 'targetActionCategory', ACTION_CATEGORY.POPUP_REACTION)
              }
            }
          } else if (f.filterType === activityMedicalTrendTypeCode.value) {
            if (f.targetActionType === null || f.targetActionType === undefined) {
              set(f, 'targetActionType', ACTION_TYPE.CONTENT_VIEWER)
            } else if (f.targetActionType === ACTION_TYPE.POST_VIEWER) {
              set(f, 'targetActionType', ACTION_TYPE.CONTENT_VIEWER)
            }
          } else if (f.filterType === activitySurveyTypeCode.value) {
            if (f.targetActionType === null || f.targetActionType === undefined) {
              set(f, 'targetActionType', ACTION_TYPE.SURVEY_COMPLETER)
            }
          }
          // _showDetails 유지 (BE 응답에 없을 수 있음)
          // eslint-disable-next-line no-underscore-dangle
          if (f._showDetails === undefined) set(f, '_showDetails', true)
        })
      }
    }, { immediate: true, deep: true })

    // isAndCross 값이 변경되면 모든 필터에 반영
    watch(isAndCross, newValue => {
      activityFilters.value.forEach(filter => {
        set(filter, 'isAndCross', newValue)
      })
    })
    watch(activityFilters, () => {
      if (isActivity.value && activityFilters.value.length > 0) {
        instance.proxy.$nextTick(() => {
          validate()
        })
      }
    }, { deep: true })

    const instance = getCurrentInstance()
    const refs = instance.proxy.$refs

    const selectedTableColumns = [
      {
        key: 'filterType', label: '카테고리', sortable: false, thStyle: { width: '8%' },
      },
      {
        key: 'filterId', label: 'ID', sortable: false, thStyle: { width: '8%' },
      },
      {
        key: 'clientName', label: '제약사명', sortable: false, thStyle: { width: '10%' },
      },
      { key: 'title', label: '제목', sortable: false },
      {
        key: 'isMainView', label: '메인노출', sortable: false, thStyle: { width: '8%' },
      },
      {
        key: 'isInfoPopUp', label: '처방팝업', sortable: false, thStyle: { width: '8%' },
      },
      {
        key: 'isScheduleUse', label: '스케줄팝업', sortable: false, thStyle: { width: '8%' },
      },
      {
        key: 'isAfterConsultPopup', label: '진료후팝업', sortable: false, thStyle: { width: '8%' },
      },
      {
        key: 'liveDate', label: '게시기간', sortable: false, thStyle: { width: '15%' },
      },
      {
        key: 'isDelete', label: '', sortable: false, thStyle: { width: '30px' }, tdClass: 'text-center p-0',
      },
    ]

    const createFilterItem = (item, filterTypeCode) => {
      const baseFilter = {
        filterId: item.filterId,
        filterType: filterTypeCode,
        title: item.title,
        isInfoPopUp: item.isInfoPopUp,
        isScheduleUse: item.isScheduleUse,
        isAfterConsultPopup: item.isAfterConsultPopup ?? null,
        liveDate: item.liveDate,
        filterStartDate: item.startDate,
        filterEndDate: item.endDate,
        startDate: item.startDate && dayjs(item.startDate).isAfter(yesterdayDate) ? yesterdayDate : item.startDate,
        endDate: getEndDate(item),
        isAndCross: isAndCross.value,
        _showDetails: true,
      }

      if (filterTypeCode === activityDrugInfoTypeCode.value) {
        set(item, 'targetRouteCodes', '0')
        set(item, 'targetRouteName', '전체 경로')
        return {
          ...baseFilter,
          isMainView: item.isMainView,
          clientName: item.clientName,
          targetActionCategory: ACTION_CATEGORY.CONTENT_VIEW,
          targetActionType: ACTION_TYPE.CONTENT_VIEWER,
          targetRouteCodes: item.targetRouteCodes,
          targetRouteName: item.targetRouteName,

          utilData: null,
        }
      } if (filterTypeCode === activityMedicalTrendTypeCode.value) {
        return {
          ...baseFilter,
          utilData: item.utilData ?? null,

          isMainView: null,
          clientName: null,
          targetActionCategory: null,
          targetActionType: ACTION_TYPE.CONTENT_VIEWER,
          targetRouteCodes: null,
          targetRouteName: null,
        }
      } if (filterTypeCode === activitySurveyTypeCode.value) {
        return {
          ...baseFilter,
          isMainView: item.isMainView,
          clientName: item.clientName,
          targetActionCategory: null,
          targetActionType: ACTION_TYPE.SURVEY_COMPLETER,
          targetRouteCodes: null,
          targetRouteName: null,

          utilData: null,
        }
      }

      return null
    }

    const addFilters = (selectedItems, filterTypeCode) => {
      if (!selectedItems || selectedItems.length === 0) return

      const existing = props.targetGroupData.targetGroupFilters.filter(x => x.filterType === filterTypeCode) || []
      const newFilters = []

      selectedItems.forEach(item => {
        const alreadyExists = existing.some(x => x.filterId === item.filterId)
        if (!alreadyExists) {
          newFilters.push(createFilterItem(item, filterTypeCode))
        }
      })

      props.targetGroupData.targetGroupFilters.push(...newFilters)
    }

    const showDrugInfoSelect = ref(false)
    const showMedicalTrendSelect = ref(false)
    const showSurveySelect = ref(false)
    const showActionRouteSelect = ref(false)
    const drugInfoSelect = {
      close: rs => {
        showDrugInfoSelect.value = false
        addFilters(rs, activityDrugInfoTypeCode.value)
      },
    }

    const medicalTrendSelect = {
      close: rs => {
        showMedicalTrendSelect.value = false
        addFilters(rs, activityMedicalTrendTypeCode.value)
      },
    }

    const surveySelect = {
      close: rs => {
        showSurveySelect.value = false
        addFilters(rs, activitySurveyTypeCode.value)
      },
    }

    const removeRow = (type, item) => {
      const idx = props.targetGroupData.targetGroupFilters.findIndex(x => x.filterType === type && x.filterId === item.filterId)
      if (idx !== -1) {
        props.targetGroupData.targetGroupFilters.splice(idx, 1)
      }
    }

    const showTargetGroupFilters = ftType => {
      if (ftType === activityDrugInfoTypeCode.value) {
        showDrugInfoSelect.value = true
        showMedicalTrendSelect.value = false
        showSurveySelect.value = false
      } else if (ftType === activityMedicalTrendTypeCode.value) {
        showDrugInfoSelect.value = false
        showMedicalTrendSelect.value = true
        showSurveySelect.value = false
      } else if (ftType === activitySurveyTypeCode.value) {
        showDrugInfoSelect.value = false
        showMedicalTrendSelect.value = false
        showSurveySelect.value = true
      }
    }

    const changeTargetActionType = item => {
      // 타겟 경로 초기화 (있는 경우 전체 경로, 없는 경우 null)
      if (ACTION_TYPES_WITH_TARGET_ROUTE.includes(item.targetActionType)) {
        set(item, 'targetRouteCodes', '0')
        set(item, 'targetRouteName', '전체 경로')
      } else {
        set(item, 'targetRouteCodes', null)
        set(item, 'targetRouteName', null)
      }
    }
    // 약품정보 카테고리(컨텐츠 열람 기반/팝업 반응 기반) 변경 시 하위 targetActionType을 기본값으로 리셋
    const changeTargetActionCategory = item => {
      if (item.targetActionCategory === ACTION_CATEGORY.CONTENT_VIEW) {
        set(item, 'targetActionType', ACTION_TYPE.CONTENT_VIEWER)
      } else if (item.targetActionCategory === ACTION_CATEGORY.POPUP_REACTION) {
        set(item, 'targetActionType', ACTION_TYPE.POPUP_CLICKER)
      }
      changeTargetActionType(item)
    }
    const currentFilter = ref(null)
    const targetRouteSelect = {
      open: item => {
        currentFilter.value = item
        showActionRouteSelect.value = true
      },
      close: rs => {
        showActionRouteSelect.value = false

        if (rs) {
          currentFilter.value.targetRouteCodes = arrayJoinStr(rs, 'code')
          currentFilter.value.targetRouteName = arrayJoinStr(rs, 'label')
        }
        currentFilter.value = null
      },
    }

    const getFilterTypeLabel = code => {
      const labels = {
        [activityDrugInfoTypeCode.value]: '약품정보',
        [activityMedicalTrendTypeCode.value]: '메디컬트렌드',
        [activitySurveyTypeCode.value]: '설문조사',
      }
      return labels[code] || ''
    }

    const validate = () => {
      const validations = []
      validations.push(refs.activityRules.validate())
      return Promise.all(validations).then(valids => {
        const result = valids.every(Boolean)
        emit('valid-change', result)
        return result
      })
    }

    const getEndDate = item => {
      if (!item.endDate) return null

      const checkMonth = item.filterType === activityMedicalTrendTypeCode.value ? 2 : 3
      if (Math.abs(dayjs(item.endDate).diff(dayjs(item.startDate), 'month', true)) > checkMonth) {
        return dayjs(item.startDate).add(checkMonth, 'month').format('YYYY-MM-DD')
      }

      if (dayjs(item.endDate).isAfter(yesterdayDate)) {
        return yesterdayDate
      }

      return item.endDate
    }

    return {
      isActivity,
      activityFilters,
      currentFilter,
      getFilterTypeLabel,
      selectedFilterIds,
      activityDrugInfoTypeCode,
      activityMedicalTrendTypeCode,
      activitySurveyTypeCode,
      showDrugInfoSelect,
      showMedicalTrendSelect,
      showSurveySelect,
      drugInfoSelect,
      medicalTrendSelect,
      surveySelect,
      showTargetGroupFilters,
      removeRow,
      isAndCross,
      dayjs,
      yesterdayDate,
      getEndDate,
      selectedTableColumns,
      ActionRouteSelect,
      targetRouteSelect,
      changeTargetActionType,
      changeTargetActionCategory,
      showActionRouteSelect,
      validate,
      // 신규 액션타입 상수/옵션
      ACTION_TYPE,
      ACTION_CATEGORY,
      drugInfoActionCategoryOptions,
      contentViewActionOptions,
      popupReactionActionOptions,
      surveyActionOptions,
      showDateRangeRow,
      showTargetRouteRow,
    }
  },
}
</script>

<style>
.btn-hover-trash:hover {
  background: linear-gradient(to right, #ffe5e5, #ffcccc);
  border-radius: 4px;
}

/* hover 효과 완전 제거 */
.no-hover-row:hover,
.table-hover .no-hover-row:hover {
  background-color: #fff !important;
}

/* row-details와 위 행 사이의 경계선 제거 및 스타일링 */
.b-table-has-details > td {
  border-bottom: 0 !important;
}

.b-table-details > td {
  padding: 12px !important;
  border-top: 0 !important;
  background-color: #fff !important;
}

/* details 영역 카드 스타일 */
.details-card {
  border: none !important;
  background-color: #f8f9fa !important;
  border-radius: 4px !important;
}

/* details 영역 테이블 스타일 */
.details-table {
  background-color: #f8f9fa !important;
  margin: 0 !important;
  border-radius: 4px !important;
}

.details-table tbody tr td {
  border: none !important;
  padding: 12px 16px !important;
}

.details-table tbody tr {
  border-bottom: 1px solid #e9ecef !important;
}

.details-table tbody tr:last-child {
  border-bottom: none !important;
}
</style>
